import React, { createContext, useContext, useEffect, useState } from 'react';
import { loadStore, saveStore, createDefaultStore } from './fhcStore';

const FhcStoreContext = createContext(null);

export function FhcStoreProvider({ children }) {
  const [store, setStore] = useState(() => loadStore());

  useEffect(() => {
    saveStore(store);
  }, [store]);

  const updateCollection = (key, value) => {
    setStore(prev => ({ ...prev, [key]: value }));
  };

  const resetStore = () => {
    const data = createDefaultStore();
    setStore(data);
  };

  return (
    <FhcStoreContext.Provider value={{ store, updateCollection, resetStore }}>
      {children}
    </FhcStoreContext.Provider>
  );
}

export function useFhcStore() {
  const context = useContext(FhcStoreContext);
  if (!context) {
    throw new Error('useFhcStore must be used within FhcStoreProvider');
  }
  return context;
}
